import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetModelTreeResData extends ApiGenericResponse {
    modelTree: string = "";

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ModelTree) this.modelTree = obj.ModelTree;
    }
}
